module.exports = __webpack_public_path__ + "static/img/14001041.c6b47c9b.png";